export default __webpack_public_path__ + "static/media/IS.fa998bd0.svg";